/**
 * How visible each drawn storey is this frame, for art drawn on ANOTHER storey that belongs with it:
 * an upper floor's slab faces hang in the storey below (storey_edges.ts), so they fade with the
 * floor they belong to. The active storey publishes 1; a passive one its root's alpha, and the cells
 * of a regional cutaway (the structure the player stands under, see SceneFloorRenderer) their own fade.
 */
interface StoreyVisibility { alpha: number; region?: ReadonlySet<string>; regionAlpha: number }

const storeys = new Map<string, StoreyVisibility>()

export const publishStoreyVisibility = (roomId: string, alpha: number,
    region?: ReadonlySet<string>, regionAlpha = 1): void => {
    storeys.set(roomId, { alpha, region, regionAlpha })
}

export const withdrawStoreyVisibility = (roomId: string): void => { storeys.delete(roomId) }

/** 0..1; a storey nobody published is drawn as usual. */
export const storeyCellAlpha = (roomId: string, x: number, y: number): number => {
    const storey = storeys.get(roomId)
    if (!storey) return 1
    return storey.alpha * (storey.region?.has(`${x},${y}`) ? storey.regionAlpha : 1)
}
